import Button from '@platform-ui-common/components/Button/index.js';
import ErrorDisplay from '@platform-ui-common/components/ErrorDisplay/index.js';
import Typography from '@platform-ui-common/components/Typography/index.js';
import Color, { BackgroundColors } from '@platform-ui-common/utilities/Color.js';
import cx from 'classnames';
import React from 'react';

interface ReviewSectionProps {
  title: string;
  children: React.ReactNode;
  onEdit?: () => void;
  isComplete?: boolean;
}

// TODO better abstraction here?
function ReviewPanel({
  title,
  children,
  onEdit,
  isComplete = false,
}: ReviewSectionProps): JSX.Element {
  return (
    <div className="flex flex-col justify-between gap-2">
      <div
        className={cx(
          `${BackgroundColors[Color.LightBackground]} py-6 px-6 lg:px-8 rounded grow`,
          !isComplete && 'border border-error',
        )}
      >
        <div className="flex gap-6 justify-between mb-3">
          <Typography variant="h2">{title}</Typography>
          {onEdit && (
            <Button
              icon="edit"
              type="button"
              variant="text"
              textColor={Color.Primary}
              onClick={onEdit}
            >
              <Typography variant="label" bold>
                Edit
              </Typography>
            </Button>
          )}
        </div>
        <div className="flex flex-col gap-4">{children}</div>
      </div>
      <ErrorDisplay message="Section incomplete" visible={!isComplete} />
    </div>
  );
}

export default ReviewPanel;
